import {
  Users,
  Utensils,
  Flame,
  Palmtree,
  Armchair,
  ShowerHead,
  Wifi,
  Car,
  Home,
  Anchor,
  Waves,
  GlassWater,
  Zap,
  Droplet,
  Bed,
  CheckCircle2,
  type LucideIcon,
} from "lucide-react";

const RULES: Array<{ test: RegExp; Icon: LucideIcon }> = [
  { test: /(entry for|guests?|people|persons?)/i, Icon: Users },
  { test: /(picnic|table|utensil|dining)/i, Icon: Utensils },
  { test: /(barbecue|bbq|grill|fire ?pit|fire)/i, Icon: Flame },
  { test: /(hammock)/i, Icon: Bed },
  { test: /(palm|thatch|palapa)/i, Icon: Palmtree },
  { test: /(seating|chair|sofa|lounge)/i, Icon: Armchair },
  { test: /(restroom|bathhouse|bath|shower)/i, Icon: ShowerHead },
  { test: /(wi-?fi|internet)/i, Icon: Wifi },
  { test: /(parking|car)/i, Icon: Car },
  { test: /(cabin|cabana|roof|house)/i, Icon: Home },
  { test: /(dock)/i, Icon: Anchor },
  { test: /(ladder|water entry|swim)/i, Icon: Waves },
  { test: /(bar top|bar)/i, Icon: GlassWater },
  { test: /(electric|power)/i, Icon: Zap },
  { test: /(water)/i, Icon: Droplet },
];

export function iconForBullet(text: string): LucideIcon {
  for (const r of RULES) if (r.test.test(text)) return r.Icon;
  return CheckCircle2;
}
